import './styles/form-steps.css';

// The numbered indicator from design/referencias/form.png: a circle per step
// joined by a rule, the current one filled with the accent.
//
// WHEN A FORM DESERVES ONE. Not by field count — by whether the steps are
// really different questions. Splitting four fields into four screens adds
// three clicks and no clarity, which is why clients and teams stay on one
// page. A task, on the other hand, asks where it lives, what has to be done
// and how it will be accepted: three answers from three different heads.
//
// EDIT FORMS NEVER GET ONE. Editing is "fix one field and save"; making
// somebody walk three screens to correct a typo is hostile.
//
// Going BACK is always allowed and needs no validation — nothing is sent
// until the last step. Going FORWARD is not: each step validates its own
// fields, so an error is caught next to the field that caused it and not
// three screens later.

export default function FormSteps({ steps, current, onStep }) {
    return (
        <ol className="form-steps" aria-label="Pasos del formulario">
            {steps.map((step, index) => {
                const done = index < current;
                const active = index === current;
                // Only visited steps are clickable. Jumping ahead would skip
                // the validation the step in between is there to do.
                const reachable = index <= current;

                return (
                    <li
                        className={`form-step ${active ? 'form-step--active' : ''} ${done ? 'form-step--done' : ''}`}
                        key={step.title}
                    >
                        <button
                            type="button"
                            className="form-step__dot"
                            onClick={() => reachable && onStep(index)}
                            disabled={!reachable}
                            aria-current={active ? 'step' : undefined}
                        >
                            {index + 1}
                        </button>

                        <span className="form-step__title">{step.title}</span>

                        {index < steps.length - 1 && (
                            <span className="form-step__line" aria-hidden="true" />
                        )}
                    </li>
                );
            })}
        </ol>
    );
}

// Keeps only the errors belonging to this step's fields.
//
// The whole record is validated every time, and then filtered: writing a
// second, per-step validator would be a second copy of the rules, and the two
// would drift the day a limit changes.
export function errorsForStep(allErrors, fields) {
    const found = {};
    for (const field of fields) {
        if (allErrors[field]) found[field] = allErrors[field];
    }
    return found;
}
